export const ds_SpacerLayoutBlock_Entry = `
    fragment ds_SpacerLayoutBlock_Entry on ds_SpacerLayoutBlock_Entry {
        id
        canonicalUid
        spacer_ColorPalette
        spacer_ColorTheme

        spacer_Padding
        spacer_ShowDividerLine
        spacer_DividerLineOrientation
    }
`
